// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"885e86fc","72":"2f04f3e8","477":"8675a88f","627":"f8066be4","663":"411c650a","667":"397c9b81","777":"c0eddf96","803":"25d416f6","820":"fc000cc2"}[chunkId] + ".chunk.js";
};